import {useIntl} from 'react-intl'
import {TModuleListPagination} from '../_types'
import React, {memo, useCallback, useMemo} from 'react'
import Select from 'react-select'
import clsx from 'clsx'
import {KTSVG} from '../../../../../_metronic/helpers'

export const Pagination: React.FC<TModuleListPagination> = memo((props) => {
    const {
        detail,
        filter: {page: filterPage, limit},
        setFilter,
        isNewUI,
        settingsLimit,
    } = props
    const intl = useIntl()
    const activePage = filterPage ?? 1
    const handlePageChange = (value: string | number) => {
        if (!detail) {
            return
        } else {
            if (typeof value === 'number') {
                return setFilter((prev: any) => {
                    const filterValuesClone = {...prev}
                    filterValuesClone.page = value
                    return filterValuesClone
                })
            } else {
                if (value === 'Назад') {
                    return setFilter((prev: any) => {
                        if (activePage > 1) {
                            const filterValuesClone = {...prev}
                            filterValuesClone.page = activePage - 1
                            return filterValuesClone
                        } else {
                            return prev
                        }
                    })
                } else if (value === 'Вперёд') {
                    return setFilter((prev: any) => {
                        if (activePage < detail.pages_count) {
                            const filterValuesClone = {...prev}
                            filterValuesClone.page = activePage + 1
                            return filterValuesClone
                        } else {
                            return prev
                        }
                    })
                }
            }
        }
    }

    const pagesFromDetailAsArray = useMemo(() => {
        const paginationArray: Array<number> = []
        if (detail?.pages_count) {
            for (let page = 1; page <= detail.pages_count; page++) {
                paginationArray.push(page)
            }
        }
        return paginationArray
    }, [detail])

    const paginationItems = useMemo(() => {
        const limit = 5
        if (activePage < limit) {
            return pagesFromDetailAsArray.slice(0, limit)
        } else if (activePage + limit > pagesFromDetailAsArray.length) {
            return pagesFromDetailAsArray.slice(pagesFromDetailAsArray.length - limit)
        } else {
            const indexOfActivePage = pagesFromDetailAsArray.indexOf(activePage)
            return pagesFromDetailAsArray.slice(
                indexOfActivePage - Math.floor(limit / 2),
                indexOfActivePage + Math.ceil(limit / 2)
            )
        }
    }, [pagesFromDetailAsArray, activePage])

    const defaultLimitValues = useMemo(() => [20, 40, 60, 80, 100, 200], [])

    const limitOptions = useMemo(() => {
        const customLimitValues: number[] = []

        if (Array.isArray(settingsLimit)) {
            for (const settingsLimitValue of settingsLimit) {
                const parsedLimitValue = Number(settingsLimitValue)

                if (Number.isFinite(parsedLimitValue) && parsedLimitValue > 0) {
                    customLimitValues.push(parsedLimitValue)
                }
            }
        }

        const mergedLimitValuesSorted = Array.from(
            new Set([...defaultLimitValues, ...customLimitValues])
        ).sort((a, b) => a - b)

        return mergedLimitValuesSorted.map((limitValue) => ({
            label: String(limitValue),
            value: limitValue,
        }))
    }, [settingsLimit, defaultLimitValues])

    const currentLimitValue = useMemo(() => {
        return (
            limitOptions.find((limitOption) => limitOption.value === limit) ?? {
                label: String(limit),
                value: limit,
            }
        )
    }, [limitOptions, limit])

    const handleLimitChange = useCallback((value: {label: string; value: number}) => {
        const selectedLimit = value.value
        setFilter((prev: any) => {
            const filterValuesClone = {...prev}
            filterValuesClone.limit = selectedLimit
            filterValuesClone.page = 1
            return filterValuesClone
        })
    }, [])

    if (!detail) {
        return null
    }

    return (
        <div className='pagination_container'>
            {isNewUI ? (
                <>
                    <div className='pagination_details'>
                        {`${intl.formatMessage({id: 'PAGINATION.FIRST_LABEL'})} ${
                            detail.rows_count === 0 ? 0 : limit * (activePage - 1) + 1
                        } ${intl.formatMessage({id: 'PAGINATION.SECOND_LABEL'})} ${
                            limit * activePage > detail.rows_count
                                ? detail.rows_count
                                : limit * activePage
                        }${
                            detail.rows_count
                                ? ` ${intl.formatMessage({id: 'PAGINATION.THIRD_LABEL'})} ${
                                      detail.rows_count
                                  }`
                                : ''
                        }`}
                    </div>
                    <div className='pagination_limitContainer'>
                        <Select
                            classNamePrefix='pagination_limit'
                            options={limitOptions}
                            value={currentLimitValue}
                            /* @ts-ignore */
                            onChange={handleLimitChange}
                            menuPortalTarget={document.body}
                            styles={{menuPortal: (base) => ({...base, zIndex: 9999})}}
                            maxMenuHeight={150}
                            menuPlacement='auto'
                        />
                    </div>
                </>
            ) : (
                <>
                    <div className='pagination_limitContainer'>
                        <Select
                            classNamePrefix='pagination_limit'
                            options={limitOptions}
                            value={currentLimitValue}
                            /* @ts-ignore */
                            onChange={handleLimitChange}
                            menuPortalTarget={document.body}
                            styles={{menuPortal: (base) => ({...base, zIndex: 9999})}}
                            maxMenuHeight={150}
                            menuPlacement='auto'
                        />
                    </div>
                    <div className='pagination_details'>
                        {`${intl.formatMessage({id: 'PAGINATION.FIRST_LABEL'})} ${
                            detail.rows_count === 0 ? 0 : limit * (activePage - 1) + 1
                        } ${intl.formatMessage({id: 'PAGINATION.SECOND_LABEL'})} ${
                            limit * activePage > detail.rows_count
                                ? detail.rows_count
                                : limit * activePage
                        }${
                            detail.rows_count
                                ? ` ${intl.formatMessage({id: 'PAGINATION.THIRD_LABEL'})} ${
                                      detail.rows_count
                                  }`
                                : ''
                        }`}
                    </div>
                </>
            )}
            <div className='pagination_pages'>
                <div id='kt_table_users_paginate'>
                    <ul className='pagination'>
                        <li className={clsx('page-item', {previous: true})}>
                            <a
                                className={clsx('page-link', {
                                    'page-text': !isNewUI,
                                    'me-5': !isNewUI,
                                })}
                                onClick={() => handlePageChange('Назад')}
                                style={{cursor: 'pointer', userSelect: 'none'}}
                            >
                                {isNewUI ? (
                                    <KTSVG path={`/media/crm/icons/newUI/leftArrow.svg`} />
                                ) : (
                                    <>{intl.formatMessage({id: 'BUTTON.PREVIOUS'})}</>
                                )}
                            </a>
                        </li>
                        {paginationItems.map((page) => (
                            <li
                                key={page}
                                className={clsx('page-item', {active: page === activePage})}
                            >
                                <a
                                    className='page-link'
                                    onClick={() => handlePageChange(page)}
                                    style={{cursor: 'pointer', userSelect: 'none'}}
                                >
                                    {page}
                                </a>
                            </li>
                        ))}
                        <li className={clsx('page-item', {next: true})}>
                            <a
                                className={clsx('page-link', {'page-text': !isNewUI})}
                                onClick={() => handlePageChange('Вперёд')}
                                style={{cursor: 'pointer', userSelect: 'none'}}
                            >
                                {isNewUI ? (
                                    <KTSVG path={`/media/crm/icons/newUI/rightArrow.svg`} />
                                ) : (
                                    <>{intl.formatMessage({id: 'BUTTON.NEXT'})}</>
                                )}
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    )
})
